import { render, staticRenderFns } from "./AddHolidayPage.vue?vue&type=template&id=ee968bc2&"
import script from "./AddHolidayPage.vue?vue&type=script&lang=js&"
export * from "./AddHolidayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports